import { render } from "./user_card.vue?vue&type=template&id=33645328"
import script from "./user_card.js?vue&type=script&lang=js"
export * from "./user_card.js?vue&type=script&lang=js"

import "./user_card.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__